import { getOpenClose } from './getOpenClose';
import { isTimeBetween } from './isTimeBetween';

/**
 * Checks if a location is currently open based on its hours of operation.
 * @param {Hours} hours - The hours of operation for the location.
 * @param {string} currentDay - The current day of the week (e.g., 'monday').
 * @param {string} currentTime - The current time in 'HH:MM AM/PM' format.
 * @returns {boolean} True if the location is open, false otherwise.
 */
export const checkIfOpen = (hours, currentDay, currentTime) => {
	if (!hours) return false;
	const hoursToday = hours[currentDay];
	if (!hoursToday) return false;
	const [open, close] = getOpenClose(hoursToday);
	// Handle closed status
	if (open === 'Closed' || close === 'Closed') return false;
	return isTimeBetween(currentTime, open, close);
};
